import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Money = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 2.93788C27 1.87449 26.1046 1.01245 25 1.01245C23.8954 1.01245 23 1.87449 23 2.93788V8.41663H19.7917C17.3274 8.41663 14.964 9.39557 13.2215 11.1381C11.4789 12.8806 10.5 15.244 10.5 17.7083C10.5 20.1726 11.4789 22.536 13.2215 24.2785C14.964 26.021 17.3274 27 19.7917 27H23V37.5833H12.5C11.3954 37.5833 10.5 38.4787 10.5 39.5833C10.5 40.6879 11.3954 41.5833 12.5 41.5833H23V47.0623C23 48.1257 23.8954 48.9877 25 48.9877C26.1046 48.9877 27 48.1257 27 47.0623V41.5833H30.2083C32.6726 41.5833 35.036 40.6044 36.7785 38.8618C38.5211 37.1193 39.5 34.7559 39.5 32.2916C39.5 29.8273 38.5211 27.464 36.7785 25.7214C35.036 23.9789 32.6726 23 30.2083 23H27V12.4166H35.4167C36.5212 12.4166 37.4167 11.5212 37.4167 10.4166C37.4167 9.31206 36.5212 8.41663 35.4167 8.41663H27V2.93788ZM23 12.4166H19.7917C18.3882 12.4166 17.0423 12.9741 16.0499 13.9665C15.0575 14.9589 14.5 16.3049 14.5 17.7083C14.5 19.1117 15.0575 20.4577 16.0499 21.4501C17.0423 22.4424 18.3882 23 19.7917 23H23V12.4166ZM27 27V37.5833H30.2083C31.6118 37.5833 32.9577 37.0258 33.9501 36.0334C34.9425 35.041 35.5 33.6951 35.5 32.2916C35.5 30.8882 34.9425 29.5422 33.9501 28.5499C32.9577 27.5575 31.6118 27 30.2083 27H27Z"
        fill={color}
      />
    </svg>
  )
}
